class Tool {
    /**
     * 空校验 null 或“”都返回true
     */
    static isEmpty(obj) {
        if (typeof obj === 'string') {
            return !obj || obj.replace(/\s+/g, "") === "";
        } else {
            return (!obj || JSON.stringify(obj) === "{}" || obj.length === 0);
        }
    }

    static isNotEmpty(obj) {
        return !this.isEmpty(obj);
    }

    static isUndefined(obj) {
        return obj === undefined;
    }

    static isDefined(obj) {
        return obj !== undefined;
    }

    static copy(obj) {
        if (Tool.isNotEmpty(obj)) {
            return JSON.parse(JSON.stringify(obj));
        }
    }

    /**
     * 属性图递归
     */
    static array2Tree(array, parentId) {
        if (Tool.isEmpty(array)) {
            return [];
        }
        const result = [];
        for (let i = 0; i < array.length; i++) {
            const c = array[i];
            if (Number(c.parent) === Number(parentId)) {
                const children = Tool.array2Tree(array, c.id);
                if (Tool.isNotEmpty(children)) {
                    c.children = children;
                }
                result.push(c);
            }
        }
        return result;
    }

    /**
     * 随机生成[len]长度的[radis]进制数
     */
    static uuid(len, radis = 62) {
        const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        const uuid = [];
        radis = radis || chars.length;
        for (let i = 0; i < len; i++) {
            uuid[i] = chars[0 | Math.random() * radis];
        }
        return uuid.join('');
    }
}

export default Tool;